module.exports = __webpack_public_path__ + "static/media/octes8h_1.a534e16c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_1.svg
// module id = 746
// module chunks = 0